module.exports = __webpack_public_path__ + "static/media/audius.da3cac92.svg";